import React from "react";
import PropTypes from "prop-types";

const TrailingIcon = ({
  alt = "TrailingIcon",
  className = "",
  size = 24,
  onClick = () => { },
}) => (
  <svg
    aria-label={alt}
    className={`link-icon ${className}`}
    width={size}
    height={size}
    onClick={onClick}
    viewBox="0 0 24 24"
    fill="none"
    aria-labelledby="TrailingIcon"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="InfoCircleIcon">{alt}</title>
    <path d="M2 2H9V4H4V20H20V15H22V22H2V2Z" fill="#007C89" />
    <path d="M20 5.41417V11H22V2H13V4H18.5857L9.29289 13.2928L10.7071 14.7071L20 5.41417Z" fill="#007C89" />
  </svg>
);

TrailingIcon.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default TrailingIcon;
